
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const messageApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getMessages: build.query<any, void>({
      query: () => ({
        url: appEndpoint.contactMessages,
        method: 'get',
      }),
      providesTags: ['Messages'],
    }),

    

    deleteMessage: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.contactMessages}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Messages'],
    }),

  }),
  overrideExisting: false,
});

export const {
  useGetMessagesQuery,
  useDeleteMessageMutation
} = messageApi;